"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var Money_1 = __importDefault(require("components/Money"));
var Text_1 = __importDefault(require("shared/components/Text"));
var Graph_1 = require("./styles/Graph");
var SpendBarGraph = function (_a) {
    var maxSpend = _a.maxSpend, scale = _a.scale;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Graph_1.YAxis, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, { sx: { opacity: scale * 3 < maxSpend ? 1 : 0 } }), (0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)("div", {})] }), (0, jsx_runtime_1.jsxs)(Graph_1.AxisLabels, __assign({ level: "caption" }, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption", sx: { opacity: scale * 3 < maxSpend ? 1 : 0 } }, { children: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: scale * 4, isShortened: true }) })), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: "caption" }, { children: [' ', (0, jsx_runtime_1.jsx)(Money_1.default, { amount: scale * 3, isShortened: true })] })), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: "caption" }, { children: [' ', (0, jsx_runtime_1.jsx)(Money_1.default, { amount: scale * 2, isShortened: true })] })), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: "caption" }, { children: [' ', (0, jsx_runtime_1.jsx)(Money_1.default, { amount: scale, isShortened: true })] }))] }))] }));
};
exports.default = SpendBarGraph;
